import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import "../index.css"

import { Button, CalendarField, DropDownField, TextInputField } from "../../../helpers";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { insertVendorPayment } from "../../../services/api/vendorPayment";
import { round } from "../../../utils";
import { SELLERPO_VP_MIN_PRICE_DIFF } from "../../../constants";

import ConfirmDialog from "./ConfirmDialog";
import { Dialog } from "primereact/dialog";

const paymentTermLabelMap = {
	payAdvPO: "Advance Against PO",
	payAdvDelivery: "Advance before Delivery",
	payPDCDelivery: "PDC on Delivery",
	payOnDelivery: "On Delivery",
	payCredit: "Credit"
}

/*
const paymentModeOptions = [
    {label: "CASH", value: "CASH"},
    {label: "CREDIT", value: "CREDIT"},
    {label: "BANK TRANSFER", value: "BANK TRANSFER"},
    {label: "CHEQUE", value: "CHEQUE"},
    {label: "ONLINE", value: "ONLINE"}
]
*/

const PaymentRequest = (props) => {
    const {vendorPayments, getSellerPO, pmCompanyConfig, setIsLoading, paymentTerms, sellerPO, sellerPOItems, sellerPIPunch, sellerGRNQCPunch, sellerPOPaymentDetails, prendingApprovalsExist} = props
	const {piPunchPaymentDetails} = sellerPOPaymentDetails

    const [selectedDocument, setSelectedDocument] = useState("")
	const [vendorPaymentReq, setVendorPaymentReq] = useState({})
    const [pettycashType, setPettycashType] = useState("")
    const [requestAmount, setRequestAmount] = useState(0)
    const [remarks, setRemarks] = useState("")
	const [visibleConfirmDialog, setVisibleConfigDialog] = useState(false)

	const dispatch = useDispatch()
    const userId = useSelector((state) => state.userDetails.userId)

	useEffect(() => {
		if(props.vendorPaymentReq){
			setVendorPaymentReq({...props.vendorPaymentReq})
			if(props.vendorPaymentReq.payableAmount > pmCompanyConfig?.maxCashAllowedVPAmount && props.vendorPaymentReq.paymentMode === "CASH"){
				setRequestAmount(pmCompanyConfig.maxCashAllowedVPAmount)
			} else {
				setRequestAmount(props.vendorPaymentReq.payableAmount)
			}
			setSelectedDocument(props.vendorPaymentReq.selectedDocument)
		}
	}, [props.vendorPaymentReq])

	const handlePettycashTypeChange = (event) => {
		setPettycashType(event.target.value)
	}

	const handleRequestableAmountChange = (event) => {
		if(vendorPaymentReq.paymentMode === 'CASH'){
            if(parseFloat(event.target.value) > pmCompanyConfig.maxCashAllowedVPAmount){
				dispatch(raiseToast({severity:'error', detail: `Payable amount can't be greater than ${pmCompanyConfig.maxCashAllowedVPAmount} for payment mode 'CASH'`}))
				setRequestAmount(pmCompanyConfig.maxCashAllowedVPAmount)
            } else {
				setRequestAmount(event.target.value)
			}
        } else {
			setRequestAmount(event.target.value)
		}
	}

	const handlePaymentModeChange = (event) => {
		if(event.target.value === 'CASH'){
            if(requestAmount > pmCompanyConfig.maxCashAllowedVPAmount){
				dispatch(raiseToast({severity:'error', detail: `Payable amount can't be greater than ${pmCompanyConfig.maxCashAllowedVPAmount} for payment mode 'CASH'`}))
                setRequestAmount(pmCompanyConfig.maxCashAllowedVPAmount)
            }
			vendorPaymentReq.paymentDate = new Date()
        } else {
			if(selectedDocument === 'sellerpo'){
			
				
			} else {
				const relatedPIPunch = sellerPIPunch.find(eachPIPunch => eachPIPunch.sellerPIPunchId === selectedDocument)
				const firstGRNQCPunch = sellerGRNQCPunch.length > 0 ? sellerGRNQCPunch[0] : null

				let creditPeriod = 0
				if(paymentTerms.creditPeriod){
					creditPeriod = paymentTerms.creditPeriod
				}

				if(!firstGRNQCPunch.createdAt){
					return dispatch(raiseToast({severity:'error', detail: `product received date not found on pipunch no : ${relatedPIPunch.docNo}`, life: 3000}))
				}
				let productReceivedDate = new Date(firstGRNQCPunch.createdAt)

				if(event.target.value === 'CHEQUE' && vendorPaymentReq.paymentTerm === 'payCredit'){
					if(productReceivedDate){
						vendorPaymentReq.paymentDate = new Date(productReceivedDate.setDate(productReceivedDate.getDate() + creditPeriod))
						vendorPaymentReq.minPaymentDate = vendorPaymentReq.paymentDate
					}
				} else if(event.target.value === 'CHEQUE'){
					vendorPaymentReq.paymentDate = new Date()
				}
				if(event.target.value === 'CREDIT'){
					vendorPaymentReq.paymentDate = vendorPaymentReq.minPaymentDate
				}
			}
		}

		vendorPaymentReq.paymentMode = event.target.value

		if(['ONLINE', 'BANK TRANSFER'].includes(event.target.value)){
			vendorPaymentReq.paymentDate = new Date()
			vendorPaymentReq.minPaymentDate = new Date()
		}

		setVendorPaymentReq({...vendorPaymentReq})
		setPettycashType("")
	}

	const handlePaymentTermChange = (event) => {
		vendorPaymentReq.paymentTerm = event.target.value

		if(["payAdvDelivery", "payAdvPO"].includes(vendorPaymentReq.paymentTerm)){
			vendorPaymentReq.paymentDate = new Date()
			vendorPaymentReq.paymentMode = null
		} else {
			console.log("paymentTerms.creditPeriod", paymentTerms.creditPeriod)
			vendorPaymentReq.paymentDate = new Date(new Date().setDate(new Date().getDate() + paymentTerms.creditPeriod))
			console.log("paymentDate", vendorPaymentReq.paymentDate)
            vendorPaymentReq.minPaymentDate = vendorPaymentReq.paymentDate
			vendorPaymentReq.paymentMode = 'CHEQUE'
		}
		
		setVendorPaymentReq({...vendorPaymentReq})
	}

	const handleRemarksChange = (event) => {
		setRemarks(event.target.value)
	}

	const handlePaymentDateChange = (date) => {
		vendorPaymentReq.paymentDate = date
	}

	const requestVendorPayment = async (confirmation, serviceTDSDeclaration) => {
		let TDSVendorPayment

		let TDSPaymentReqExists = false
		let TDSAmount
		let relatedSellerPIPunch

		/*if(!requestAmount){
			return dispatch(raiseToast({severity:'error', detail: `Request Amount should be greater than 0`, life: 3000}))
		}*/

		const requestAmountValue = parseFloat(requestAmount)

		if(!vendorPaymentReq.paymentMode || !vendorPaymentReq.paymentTerm){
			return dispatch(raiseToast({severity:'error', detail: `Something went wrong`, life: 3000}))
		}

		if(!vendorPaymentReq.paymentDate){
			return dispatch(raiseToast({severity:'error', detail: `Please select payment data`}))
		}

		if(requestAmountValue > vendorPaymentReq.payableAmount){
			return dispatch(raiseToast({severity:'error', detail: `Request Amount should be not more than ${vendorPaymentReq.payableAmount}`, life: 3000}))
		}

		if(requestAmountValue < 50000 && vendorPaymentReq.paymentMode === 'CHEQUE'){
			return dispatch(raiseToast({severity:'error', detail: `Can't use CHEQUE payment mode if the requested amount is less than 50000`}))
		}

		if(vendorPaymentReq.selectedDocument !== 'sellerpo'){
			let pipunch = sellerPOPaymentDetails.piPunchPaymentDetails.find(pi => pi.sellerPIPunchId === vendorPaymentReq.selectedDocument)
			if(pipunch){
				
				if(pipunch.piActualTDSAmount){
					TDSPaymentReqExists = true
					TDSAmount = pipunch.piActualTDSAmount
				}
				relatedSellerPIPunch = pipunch
			}
			TDSVendorPayment = vendorPayments.find(vp => {
				if(![6, 8, 11, 2].includes(vp.statusId)){ // 'CANCELLED', 'REJECTED', 'PAYMENTREJECTED'
					if(vp.tdsAmount && vp.paymentTerm === vendorPaymentReq.paymentTerm && vp.purchaseInvoice && vp.sellerPIPunchId === vendorPaymentReq.selectedDocument){
						return true
					}
				}
			})
		} else {
			if(sellerPOPaymentDetails.totalTDSAmount && !paymentTerms.payOnDeliveryAmount && !paymentTerms.payCreditAmount ){
				TDSAmount = sellerPOPaymentDetails.totalTDSAmount
				TDSPaymentReqExists = true
			}
			TDSVendorPayment = vendorPayments.find(vp => {
				if(![6, 8, 11, 2].includes(vp.statusId)){
					if(vp.tdsAmount){
						return true
					}
				}
			})
		}

		/*if(['BANK TRANSFER', 'CREDIT'].includes(paymentMode) && seller_details) {
            if (!seller_details.bankDetails) {
				return dispatch(raiseToast({severity:'error', detail: `Bank details not available`, life: 3000}))
            }
            if(seller_details.bankDetails){
                if(!seller_details.bankDetails.accountNumber || !seller_details.bankDetails.bankName || !seller_details.bankDetails.ifsc){
					return dispatch(raiseToast({severity:'error', detail: `All Bank details not available`, life: 3000}))
                }
            }
        }*/
		
		if(!(TDSPaymentReqExists && vendorPaymentReq.tdsAmount) && !parseFloat(requestAmountValue)){
			return dispatch(raiseToast({severity:'error', detail: `Request Amount should be greater than 0`}))
		}

		if(vendorPaymentReq.paymentMode === 'CASH'){
            if(requestAmountValue > pmCompanyConfig.maxCashAllowedVPAmount){
				return dispatch(raiseToast({severity:'error', detail: `Payable amount can't be greater than ${pmCompanyConfig.maxCashAllowedVPAmount} for payment mode 'CASH'`}))
            }
			if(!pettycashType){
				return dispatch(raiseToast({severity:'error', detail: `Please choose pettycash type`}))
			}
        } 

		const isSellerPIPunchExists = sellerPIPunch.some(eachPIPunch => eachPIPunch.statusId === 1)
		
		if(!isSellerPIPunchExists && !TDSVendorPayment && sellerPOPaymentDetails.onlyAdvancePaymentExists && sellerPO.tdsValue > 0 && sellerPOPaymentDetails.totalTDSAmount > 0 && !confirmation && !isSellerPIPunchExists){
			const isServiceHSNsProductsExists = sellerPOItems.some(eachPOItem => {
				if(eachPOItem.HSNCode.toString().slice(0, 2) === '99' && eachPOItem.HSNCode.toString().length === 6){
					return true
				}
				return false
			})
			
			const serviceProducts = sellerPOItems.filter(eachPOItem => {
				if(eachPOItem.HSNCode.toString().slice(0, 2) === '99' && eachPOItem.HSNCode.toString().length === 6){
					return true
				}
				return false
			})
			const areAllServiceProducts = serviceProducts.length === sellerPOItems.length
			
			if(!areAllServiceProducts && isServiceHSNsProductsExists){
				setVisibleConfigDialog(true)
				return
			}
		}

		let tdsAmount = vendorPaymentReq.tdsAmount

		let updatedRequestAmount = requestAmountValue
		let tdsSectionId = sellerPO.tdsSectionId
		let tdsValue = sellerPO.tdsValue

		let tdsAmtReqTypeId = null

		if(serviceTDSDeclaration){
			if(serviceTDSDeclaration === "Same"){
				let totalPayableAmount = tdsAmount + requestAmountValue
				tdsAmount = sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.TDSAmountIfServicesWerePunchedTogeather
				if(requestAmountValue > sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.sellerPOTotalPriceBeforeTax){
					updatedRequestAmount = parseFloat(sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.sellerPOTotalPriceBeforeTax) - tdsAmount + parseFloat(sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.sellerPOTotalTax)
				} else {
					updatedRequestAmount = totalPayableAmount - tdsAmount
				}
				tdsAmtReqTypeId = 1
			}
			if(serviceTDSDeclaration === "Seperate"){
				let totalPayableAmount = tdsAmount + requestAmountValue
				tdsAmount = sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.TDSAmountIfServicesWerePunchedSeperately
				if(requestAmountValue > sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.sellerPOTotalPriceBeforeTax){
					updatedRequestAmount = parseFloat(sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.sellerPOTotalPriceBeforeTax) - tdsAmount + parseFloat(sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails.sellerPOTotalTax)	
				} else {
					updatedRequestAmount = totalPayableAmount - tdsAmount
				}
				tdsAmtReqTypeId = 2
			}
		}

		const newVendorPayment = {
			userId: sellerPO.userId,
			branchId: sellerPO.branchId,
			pmBranchId: sellerPO.pmBranchId,
			createdBy: userId,
			updatedBy: userId,
			sellerPOId: sellerPO.sellerPOId,
			amount: round(updatedRequestAmount),
			paymentTerm: vendorPaymentReq.paymentTerm,
			impsFlag: false,
			tdsAmount: 0, //vendorPaymentReq.tdsAmount,
			paymentMode: vendorPaymentReq.paymentMode,
			statusId: 12,

			tdsSectionId: tdsSectionId,
			tdsValue: tdsValue,
			tdsAmtReqTypeId: tdsAmtReqTypeId
		}

		if(remarks){
			newVendorPayment.remarks = remarks
		}

		if(vendorPaymentReq.paymentMode === 'CASH' && pettycashType){
			newVendorPayment.pettyCashType = pettycashType
		}

		if(vendorPaymentReq.paymentDate){
			newVendorPayment.paymentDate = vendorPaymentReq.paymentDate
		}

		if(vendorPaymentReq.selectedDocument !== 'sellerpo'){
			newVendorPayment.piPunchId = relatedSellerPIPunch.sellerPIPunchId
			newVendorPayment.sellerPIPunchId = relatedSellerPIPunch.sellerPIPunchId
		}

		if(vendorPaymentReq.paymentMode === 'CASH'){
			newVendorPayment.pettyCashExpenseFlag = true
		}

		if(newVendorPayment.amount < 0){
			return dispatch(raiseToast({severity:'error', detail: `Payable amount can't be less than 0`}))
		}
		
		if(window.confirm('Confirm to post request ? ')){
			setIsLoading(true)
			setVisibleConfigDialog(false)
			
			let vendorPaymentRes = null
			if(TDSPaymentReqExists && tdsAmount){
				vendorPaymentRes = await insertVendorPayment({...newVendorPayment, tdsReqAmount: tdsAmount, clientVendorPayments: vendorPayments})
			} else {
				vendorPaymentRes = await insertVendorPayment({...newVendorPayment, clientVendorPayments: vendorPayments})
			}

			if(vendorPaymentRes.failure){
				setIsLoading(false)
				return dispatch(raiseToast({severity:'error', detail: vendorPaymentRes.data.error, life: 3000}))
			} else {
				getSellerPO()
			}
		}
	}

	let dateToday = new Date()
	let cashMinDate = new Date()

	if(dateToday.getDate() > 10){
		cashMinDate.setDate(1)
	} else {
		cashMinDate.setDate(10)
		cashMinDate.setMonth(cashMinDate.getMonth()-1)
	}

	let allowedPaymentModeOptions = []
	//if(piPunchPaymentDetails?.length > 1 || (piPunchPaymentDetails?.length === 1 && !sellerPOPaymentDetails.allProductsSubmittedFlag) || sellerPOPaymentDetails.isNonCashPaymentExists){
	if(false){
		
	} else {
		allowedPaymentModeOptions.push("CASH")
	}
	if(!['payPDCDelivery', 'payCredit'].includes(vendorPaymentReq.paymentTerm) && !sellerPOPaymentDetails.isCashPaymentExists){
		allowedPaymentModeOptions.push("ONLINE")
		allowedPaymentModeOptions.push("BANK TRANSFER")
	}
	if(['payPDCDelivery', 'payCredit'].includes(vendorPaymentReq.paymentTerm) && !sellerPOPaymentDetails.isCashPaymentExists){
		allowedPaymentModeOptions.push("CHEQUE")
	}
	if(vendorPaymentReq.paymentTerm === "payCredit" && !sellerPOPaymentDetails.isCashPaymentExists){
		allowedPaymentModeOptions.push("CREDIT")
	}

	let minDate = new Date()
	if(vendorPaymentReq.paymentMode === 'CREDIT'){
		minDate = vendorPaymentReq.minPaymentDate
	} else if(vendorPaymentReq.paymentMode === 'CHEQUE' && vendorPaymentReq.paymentTerm === 'payPDCDelivery' ){
		minDate = new Date(vendorPaymentReq.minPaymentDate) 
	} else if(vendorPaymentReq.paymentMode === 'CHEQUE' && vendorPaymentReq.paymentTerm === 'payCredit' ){
		minDate = vendorPaymentReq.minPaymentDate
	} else if(vendorPaymentReq.paymentMode === 'CHEQUE' && vendorPaymentReq.paymentTerm !== 'payCredit' ){
		minDate = new Date(sellerPO.createdAt).toDateString()
	}

	let isAdvancePaymentDone = false
	if(sellerPOPaymentDetails.totalAmountRequested >= sellerPOPaymentDetails.totalAdvanceAmount){
		isAdvancePaymentDone = true
	}

	let isVPTotallyRequested = false
	if(sellerPOPaymentDetails.totalAmountRequested >= sellerPOPaymentDetails.VPWiseSellerPOPaymentDetails?.grandTotalPrice){
		isVPTotallyRequested = true
	}

	let paymentReqRestrictedText = ''

	if(sellerPO.statusId === 4){ // closed
		paymentReqRestrictedText = 'Seller PO is closed'
	} else if(prendingApprovalsExist){
		paymentReqRestrictedText = 'Pending approvals found, vendor payment cant be requested'
	} else if(!piPunchPaymentDetails?.length && !sellerPOPaymentDetails.totalAdvanceAmount){
		paymentReqRestrictedText = 'Purchase Invoice needs to be puched'
	} else if(isVPTotallyRequested){
		paymentReqRestrictedText = 'Total Payment Amount Requested'
	} else if(isAdvancePaymentDone && !piPunchPaymentDetails?.length){
		paymentReqRestrictedText = 'Advance payment done, Purchase Invoice needs to be puched'
	} else if(!selectedDocument && piPunchPaymentDetails?.length > 0){
		paymentReqRestrictedText = 'Update Purchase Invoice'
	} else if(!selectedDocument){
		paymentReqRestrictedText = 'Payment requested for existing PI'
	}

	let totalPaidAmount = 0
	vendorPayments.map(eachVendorPayment => {
		if(eachVendorPayment.statusId === 10){
			totalPaidAmount += eachVendorPayment.amount 
			if(eachVendorPayment.tdsAmount){
				totalPaidAmount += eachVendorPayment.tdsAmount
			}
		}
	})

	let amountDue = round(sellerPO.totalPOAmount - totalPaidAmount)
	let VPStatus = ""

	if(sellerPO.statusId === 4){
		VPStatus = "Closed"
	} else if(sellerPO.statusId === 13){
		VPStatus = "VP PAUSED"
	} else if(vendorPayments.length == 0){
		VPStatus = "NOT INITIATED"
	} else if(amountDue <= SELLERPO_VP_MIN_PRICE_DIFF){
		VPStatus = "COMPLETED"
	} else {
		VPStatus = "PENDING"
	}

	const paymentTermOptions = []
	Object.keys(paymentTermLabelMap).map(eachTerm => {
		if(vendorPaymentReq.initialPaymentTerm === "payPDCDelivery" && !["payAdvPO", "payAdvDelivery", "payPDCDelivery"].includes(eachTerm)){
			return
		}
		const termObj = {
			label: paymentTermLabelMap[eachTerm],
			value: eachTerm
		}
		paymentTermOptions.push(termObj)
	})

    return (
		<>
			<div className="p-card">
				{ paymentReqRestrictedText ?
					<div className='' style={{textAlign:'center', fontSize:'14px'}}>
						<p>{paymentReqRestrictedText}</p>
					</div>
					:
					<div className="grid">
						<div className="flex col-12 md:col-5 flex-column md:flex-row md:pr-0 md:pb-0 px-2">
							<div className="flex flex-column col-12 md:col-3 lg:col-4 md:pl-0 md:pr-0">
								<TextInputField name="" labelText="Total Price" value={ vendorPaymentReq?.totalAmount } disabled />
							</div>
							<div className="flex flex-column col-12 md:col-3 lg:col-4 md:pr-0">
								<TextInputField name="" labelText="Amt Requested" value={ vendorPaymentReq?.amountRequested } disabled />
							</div>
							<div className="flex flex-column col-12 md:col-3 lg:col-4 md:pr-0">
								<TextInputField name="" labelText="Amount Due" value={ vendorPaymentReq?.totalAmount - vendorPaymentReq?.amountRequested } disabled />
							</div>
						</div>
						<div className="flex col-12 flex-column md:col-2 md:flex-row md:px-0 md:pt-2 md:pb-0 pl-2 pt-0 px-2">
							<div className="flex flex-column col-12 col-12 md:mb-0 pt-0 md:pt-2">
								<DropDownField name="" labelText="Payment Term" value={vendorPaymentReq?.paymentTerm} options={paymentTermOptions} onChange={handlePaymentTermChange} disabled={vendorPaymentReq.initialPaymentTerm !== "payPDCDelivery"} />
							</div>
						</div>
						<div className="flex flex-column col-12 md:col-5 md:flex-row md:px-0 md:pt-2 md:pb-0 pl-2 pt-0 px-2">
							<div className="flex flex-column col-12 md:col-3 lg:col-4 pt-0 md:pt-2 md:pr-0">
								<TextInputField name="" labelText="TDS Amount" value={ vendorPaymentReq?.tdsAmount } disabled />
							</div>
							<div className="flex flex-column col-12 md:col-3 lg:col-4 md:pr-0">
								<TextInputField name="" labelText="Payable Amount" keyfilter="pnum" min={0} value={ requestAmount } onChange={handleRequestableAmountChange} />
							</div>
						</div>
						<div className="col-12 flex flex-column md:flex-row pt-0 py-0 px-2">
							<div className="flex flex-column col-12 md:col-2 pt-0 md:pt-2 md:pl-0 md:pr-0">
								<DropDownField name="" labelText="Payment Mode" value={vendorPaymentReq?.paymentMode} options={allowedPaymentModeOptions} onChange={handlePaymentModeChange} />
							</div>
							{ vendorPaymentReq.paymentMode === "CASH" ? 
								<div className="flex flex-column col-12 md:col-2 lg:col-2 md:pr-0">
									<DropDownField name="" labelText="Pettycash type" value={pettycashType} options={["EXPENSE-CASH", "EXPENSE-CARD"]} onChange={(event) =>handlePettycashTypeChange(event)} />
								</div> : ""
							}
							{ vendorPaymentReq.paymentMode === "CASH" ? 
								<div className="flex flex-column col-12 md:col-2 md:pr-0">
									<CalendarField labelText="Payment Date" dateFormat='dd/mm/y' value={vendorPaymentReq?.paymentDate} onChange={handlePaymentDateChange} minDate={cashMinDate} showIcon />
								</div> 
								:
								<div className="flex flex-column col-12 md:col-2 md:pr-0">
									<CalendarField labelText="Payment Date" dateFormat='dd/mm/y' value={vendorPaymentReq?.paymentDate} onChange={handlePaymentDateChange} minDate={minDate} showIcon />
								</div>
							}
							<div className="flex flex-column col-12 md:col-3 lg:col-5 md:pr-0">
								<TextInputField name="" labelText="Remarks" value={ remarks } onChange={handleRemarksChange} />
							</div>
							<div className="flex md:mt-4 ml-2 mt-0 mb-1">
								<div><Button label="REQUEST" onClick={() => {requestVendorPayment()}} /></div>
							</div>
						</div>
					</div>
				}
			</div>
			<Dialog header={"Confirm Payment Details"} className="" visible={visibleConfirmDialog} style={{ width: '45vw' }} onHide={() => setVisibleConfigDialog(false)} >
				<ConfirmDialog requestVendorPayment={requestVendorPayment} />
			</Dialog>
		</>
    )
}

export default PaymentRequest;